import { z } from 'zod'
import { managerBenefitCommonSchema } from '~library/models'
import { fileDescriptionSchema } from './file-description'

/** shoppingCart Schema */
export const shoppingCartSchema = z
  .object({
    /** 回饋項目Id */
    id: z.string(),
    /** 限時促銷Id */
    flashSaleId: z.string(),
    /** 限量明細Id */
    limitedEditionDetailId: z.string(),
    /** 所需點數 */
    point: z.number(),
    /** 選購數量 */
    quantity: z.number(),
    /** 剩餘數量 */
    remainQuantity: z.number()
  })
  .merge(managerBenefitCommonSchema)
  .merge(fileDescriptionSchema)

export const myAccountGetShoppingCartSchema = z.object({
  /** 帳戶點數 */
  point: z.number(),
  /** 購物車 */
  shoppingCart: z.array(shoppingCartSchema)
})

export interface ShoppingCart extends z.infer<typeof shoppingCartSchema> {}

export interface MyAccountGetShoppingCart
  extends z.infer<typeof myAccountGetShoppingCartSchema> {}

export class MyAccountGetShoppingCart {
  constructor() {
    return {
      point: 0,
      shoppingCart: []
    }
  }
}
